import { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { LocalizedLink as Link } from "@/components/LocalizedLink";
import { useLang } from "@/i18n";
import { usePageMeta } from "@/hooks/usePageMeta";

const NotFound = () => {
  const { t } = useLang();
  const nf = t.notFound;
  usePageMeta({ title: nf.seoTitle, description: nf.text });

  // Keep wrong URLs out of search results (the host still answers 200).
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <section className="max-w-3xl mx-auto px-6 md:px-12 pt-40 pb-16 md:pt-48" data-testid="not-found-page">
      <p className="font-display italic text-7xl md:text-8xl text-terracotta/40" aria-hidden="true">404</p>
      <h1 className="font-display font-medium text-4xl md:text-6xl tracking-tight mt-4">{nf.title}</h1>
      <p className="mt-6 text-stone text-base md:text-lg leading-relaxed font-light">{nf.text}</p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="group mt-10 inline-flex items-center gap-3 rounded-full bg-terracotta px-8 py-4 text-sm font-medium text-cream hover:bg-terracotta-dark transition-colors duration-300"
      >
        {nf.cta}
        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
      </Link>
    </section>
  );
};

export default NotFound;
